// extracted by mini-css-extract-plugin
module.exports = {"container":"EditedBySimpleText_container__3VdVP","box":"EditedBySimpleText_box__1gSH-"};